import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  RESET_LOGIN_FLAG,
  RENEW_TOKEN,
  RENEW_TOKEN_SUCCESS,
  RENEW_TOKEN_ERROR,
  USER_ONLINE_STATUS,
  USER_ONLINE_STATUS_SUCCESS,
  USER_ONLINE_STATUS_ERROR,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  isUserLogout: false,
  isUserLogin: false,
  userOnlineStatus: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        isUserLogout: false,
        isUserLogin: true,
      };
      break;
    case LOGOUT_USER:
      state = { ...state, isUserLogout: false };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true, isUserLogin: false };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      };
      break;
    case RESET_LOGIN_FLAG:
      state = {
        ...state,
        error: null,
      };
      break;

    case RENEW_TOKEN:
      state = {
        ...state,
        loading: true,
        isUserLogin: true,
      };
      break;
    case RENEW_TOKEN_SUCCESS:
      state = {
        ...state,
        loading: false,
        isUserLogin: true,
      };
      break;
    case RENEW_TOKEN_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;

    case USER_ONLINE_STATUS:
      state = { ...state, userOnlineStatus: false };
      break;
    case USER_ONLINE_STATUS_SUCCESS:
      state = { ...state, userOnlineStatus: action.payload };
      break;
    case USER_ONLINE_STATUS_ERROR:
      state = { ...state, userOnlineStatus: false };
      break;

    default:
      state = { ...state };
  }

  return state;
};

export default login;
